import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DwollaService {
    /**
     * Get Client Token
     * @returns any Successful Response
     * @throws ApiError
     */
    static getClientTokenDwollaGetClientTokenPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dwolla/get_client_token',
        });
    }
    /**
     * Save Dwolla Url
     * @param url
     * @param org
     * @returns any Successful Response
     * @throws ApiError
     */
    static saveDwollaUrlDwollaSaveUrlPost(url, org) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dwolla/save_url',
            query: {
                'url': url,
                'org': org,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Mass Payment
     * this endpoint takes a source email, and a list of {destination: <destination_email>, amount: <amount>} objects,
     * and performs debit + credit from source to all destination using Dwolla.
     * Dwolla handles debit+credit internally, we just need to supply this data to the endpoint
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static massPaymentDwollaMassPaymentPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dwolla/mass_payment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Initiate Verify Bank For Customer
     * @param url
     * @returns any Successful Response
     * @throws ApiError
     */
    static initiateVerifyBankForCustomerDwollaInitiateVerifyBankPost(url) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dwolla/initiate_verify_bank',
            query: {
                'url': url,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Finish Verify Bank For Customer
     * @param url
     * @param amount1
     * @param amount2
     * @returns any Successful Response
     * @throws ApiError
     */
    static finishVerifyBankForCustomerDwollaFinishVerifyBankPost(url, amount1, amount2) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dwolla/finish_verify_bank',
            query: {
                'url': url,
                'amount_1': amount1,
                'amount_2': amount2,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Or Update Beneficiaries
     * This endpoint creates or updates customers and their bank details on dwolla using the information provided
     * in a .csv file
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static addOrUpdateBeneficiariesDwollaBeneficiariesPost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dwolla/beneficiaries',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
